<template>
  <div>
    <v-toolbar height="50" dark color="grey lighten-1">
      <v-toolbar-title :style="item.enable ? 'color: white;' : 'color: red;'">{{ item.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small depressed color="transparent" @click="onClose()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-card flat class="rounded-0" color="light-grey">
      <v-sheet :style="contentsHeight">
        <v-row align="center" class="px-4">
          <v-col cols="2"><span style="font-weight: bold;">key</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.key }}</span></v-col>
          <v-col cols="2"><span style="font-weight: bold;">imported</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.imported }}</span></v-col>
        </v-row>
        <v-row align="center" class="px-4">
          <v-col cols="2"><span style="font-weight: bold;">enable</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.enable }}</span></v-col>
          <v-col cols="2"><span style="font-weight: bold;">charge</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.charge }}</span></v-col>
        </v-row>
        <v-row align="center" class="px-4">
          <v-col cols="2"><span style="font-weight: bold;">createdAt</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.createdAt | moment }}</span></v-col>
          <v-col cols="2"><span style="font-weight: bold;">updatedAt</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.updatedAt | moment }}</span></v-col>
        </v-row>
        <v-row align="center" class="px-4">
          <v-col cols="2"><span style="font-weight: bold;">name</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.name }}</span></v-col>
          <v-col cols="1"><span style="font-weight: bold;">sei</span></v-col>
          <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.sei }}</span></v-col>
          <v-col cols="1"><span style="font-weight: bold;">mei</span></v-col>
          <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.mei }}</span></v-col>
        </v-row>
        <v-row align="center" class="px-4">
          <v-col cols="2"><span style="font-weight: bold;">grade</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.grade ? item.grade : '-' }}</span></v-col>
          <v-col cols="2"><span style="font-weight: bold;">birth</span></v-col>
          <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.birth ? item.birth : '-' }}</span></v-col>
          <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ getGrade(item) ? getGrade(item) : '-' }}</span></v-col>
        </v-row>
        <v-row align="center" class="px-4">
          <v-col cols="2"><span style="font-weight: bold;">status</span></v-col>
          <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.status }}</span></v-col>
        </v-row>
        <v-row align="center" class="px-4">
          <v-col cols="2"><span style="font-weight: bold;">admission</span></v-col>
          <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.admission ? item.admission : '-' }}</span></v-col>
          <v-col cols="2"><span style="font-weight: bold;">graduation</span></v-col>
          <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.graduation ? item.graduation : '-' }}</span></v-col>
          <v-col cols="2"><span style="font-weight: bold;">secession</span></v-col>
          <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden">{{ item.secession ? item.secession : '-' }}</span></v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <v-sheet :style="eventsHeight" class="pa-0 overflow-auto">
          <v-list class="pa-0">
            <v-list-item
              v-for="item in item.events"
              :key="item.id"
            >
            <v-list-item-content class="mt-1" :style="item.enable ? 'background-color: lightcyan;' : 'background-color: lightgray;'">
              <v-row align="center" class="px-4">
                <v-col cols="1"><span style="font-weight: bold;">id</span></v-col>
                <v-col cols="1" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.id }}</span></v-col>
                <v-col cols="2"><span style="font-weight: bold;">counter</span></v-col>
                <v-col cols="1" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.counter }}</span></v-col>
                <v-col cols="2"><span style="font-weight: bold;">status</span></v-col>
                <v-col cols="1" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.status }}</span></v-col>
                <v-col cols="2"><span style="font-weight: bold;">enable</span></v-col>
                <v-col cols="2" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.enable }}</span></v-col>
                <v-col cols="2"><span style="font-weight: bold;">date</span></v-col>
                <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.date1 ? item.date1 : '-' }}</span></v-col>
                <v-col cols="2"><span style="font-weight: bold;">grade</span></v-col>
                <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.grade ? item.grade : '-' }}</span></v-col>
                <v-col cols="2"><span style="font-weight: bold;">createdAt</span></v-col>
                <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.createdAt | moment }}</span></v-col>
                <v-col cols="2"><span style="font-weight: bold;">updatedAt</span></v-col>
                <v-col cols="4" align="end"><span class="elevation-1 px-2 py-1 rounded overflow-text-hidden" style="background-color: white;">{{ item.updatedAt | moment }}</span></v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          </v-list>
        </v-sheet>
      </v-sheet>
    </v-card>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      windowSize: 'shared/windowSize'
    }),
    items () {
      var temp = []
      return temp
    },
    item () {
      var temp = {}
      var index = this.students.findIndex(s => s.key === this.student)
      if (index !== -1) {
        temp = JSON.parse(JSON.stringify(this.students[index]))
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 50) + 'px;'
    },
    eventsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 50 - (52 * 7) - 1) + 'px;'
    }
  },
  props: ['student', 'students'],
  data () {
    return {
      loading: false
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.$emit('dismissed')
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss.SSS')
    }
  }
}
</script>

<style scoped>
 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

</style>
